module.exports = __webpack_public_path__ + "static/free-to-choose-585512a73ef2ccd93df4741c7ae7eedd.jpg";